export default "__VITE_ASSET__8a02d550__"